import { createWikoRpcApi } from '@wiko/rpc-api';
import { createRpc, RpcTransport } from '@wiko/rpc-spec';
import { ClusterUrl } from '@wiko/rpc-types';

import type { RpcFromTransport, WikoRpcApiFromTransport } from './rpc-clusters';
import { DEFAULT_RPC_CONFIG } from './rpc-default-config';
import { createDefaultRpcTransport } from './rpc-transport';

type DefaultRpcTransportConfig<TClusterUrl extends ClusterUrl> = Parameters<
    typeof createDefaultRpcTransport<TClusterUrl>
>[0];

/** Creates a new Wiko RPC using the default decorated HTTP transport. */
export function createWikoRpc<TClusterUrl extends ClusterUrl>(
    clusterUrl: TClusterUrl,
    config?: Omit<DefaultRpcTransportConfig<TClusterUrl>, 'url'>,
) {
    return createWikoRpcFromTransport(createDefaultRpcTransport({ url: clusterUrl, ...config }));
}

/** Creates a new Wiko RPC using a custom transport. */
export function createWikoRpcFromTransport<TTransport extends RpcTransport>(transport: TTransport) {
    return createRpc({
        api: createWikoRpcApi(DEFAULT_RPC_CONFIG),
        transport,
    }) as RpcFromTransport<WikoRpcApiFromTransport<TTransport>, TTransport>;
}
